import React, { memo, useCallback } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import styles from './styles';
import Utility from '../../utils/Utility';
import DebouncedTouchableOpacity from '../../components/shared/DebouncedTouchableOpacity';
import { getNavigationSource } from '../../utils/PerfUtility';
import { getScreenWidth } from '../../utils/LayoutUtility';
import Config from 'react-native-config';

const ListCartBuilderSummary = (props) => {
  const { source = 'cart_tray', navigation } = props;
  const openCart = useCallback(() => {
    navigation.push('Cart', {
      source,
    });
    // Uncomment the following lines if analytics are needed:
    // AnalyticsManager.logEvent(EventType.discoveryEvents.ITEM_ACTION, {
    //   [EventParameterKey.COUPON_CODE]: coupon_code,
    //   [EventParameterKey.ACTION]: 'view_bag',
    // });
  }, [navigation, source]);

  const stripStyle = styles.cartTrayContainerOfferContainer;

  return (
    <View style={stripStyle}>
      <View style={styles.cartTrayContainerOffer}>
        <DebouncedTouchableOpacity
          {...props}
          style={cartBuilderStyles.viewBagButton}
          onPress={openCart}
          hitSlop={Utility.getHitSlop()}
        >
          <Text style={styles.viewBagButtonText}>View Bag</Text>
        </DebouncedTouchableOpacity>
      </View>
    </View>
  );
};

export default memo(ListCartBuilderSummary);

const cartBuilderStyles = StyleSheet.create({
  viewBagButton: {
    width: getScreenWidth() - 24,
    height: 48,
    borderRadius: 8,
    backgroundColor: Config.THEME_COLOR || '#52CB8C',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
